import { config } from 'affiny-core/env';
import { IHydratedReflist } from '../api/repositories/reflists/reflists.types';
import { initialRootState } from '../initialRootState';
import { EReflistsActionType, IReflistsAction } from './actions';

export interface IReflistsState {
  entriesMe: IHydratedReflist;
  entriesOther: IHydratedReflist;
  platform?: string;
  kvk?: string;
  lang?: string;
}

export const reflistsReducer = (
  currentState: IReflistsState = initialRootState.reflists,
  action: IReflistsAction
): IReflistsState => {
  switch (action.type) {
    case EReflistsActionType.GET_SUCCESS:
      return {
        ...currentState,
        entriesMe: action.payload.me,
        entriesOther: action.payload.other,
        platform: action.payload.platform,
        kvk: action.payload.kvk,
        lang: config.env.locale,
      };
    default:
      return currentState;
  }
};
